import { render, staticRenderFns } from "./MspImpegnoDetail.vue?vue&type=template&id=04792e8c"
import script from "./MspImpegnoDetail.vue?vue&type=script&lang=js"
export * from "./MspImpegnoDetail.vue?vue&type=script&lang=js"
import style0 from "./MspImpegnoDetail.vue?vue&type=style&index=0&id=04792e8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports